/* eslint-disable camelcase */
type Locale = 'en' | 'es';
type Phrase = (l: Locale) => string;

export const i18n_introducing_our_new_docs_films: Phrase = locale => {
  const phrases: { [key: string]: undefined | string } = {
    en: `Introducing our new docs and films! Get comfy as you take a journey into ancient yogic wisdom.`,
    es: `¡Conoce nuestros nuevos documentales y películas! Ponte cómodo mientras emprendes un viaje hacia la antigua sabiduría yóguica.`,
  };
  return phrases[locale] || phrases.en || ``;
};
